<template>
  <div class="back-top small" @click="backTop()" v-show="backTopShow"></div>
</template>

<script>
  export default {
    name:'BackTop',
    data() {
      return {
        backTopShow:false
      }
    },
    components: {},
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
      backTop() {
        let back = setInterval(() => {
          if(document.body.scrollTop||document.documentElement.scrollTop){
            document.body.scrollTop-=100;
            document.documentElement.scrollTop-=100;
          }else {
            clearInterval(back)
          }
        });
      },
      handleScroll(){
        if (document.documentElement.scrollTop + document.body.scrollTop > 100) {
          this.backTopShow=true;
        }
        else {
          this.backTopShow=false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .back-top {
    position: fixed;
    right: 100px;
    bottom: 100px;
    width:60px;
    height:60px;
    cursor: pointer;
    text-align: center;
    background: url('../../static/backtop.png');
    background-size:60px 60px;
  }
  /* 1366px下样式 */
  @media screen and (max-width: 1367px) {
    .back-top {
      position: fixed;
      right: 60px;
      bottom: 60px;
      width:60px;
      height:60px;
      cursor: pointer;
      text-align: center;
      background: url('../../static/backtop.png');
      background-size:60px 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/BackTop.vue